import { render, staticRenderFns } from "./CopyrightNotice.vue?vue&type=template&id=251a33e8&scoped=true&"
import script from "./CopyrightNotice.vue?vue&type=script&lang=js&"
export * from "./CopyrightNotice.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightNotice.vue?vue&type=style&index=0&id=251a33e8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251a33e8",
  null
  
)

export default component.exports